import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { API } from "../App";

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
      toast.success("If an account exists, a reset link has been sent!");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to send reset email");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0a0a1f] via-[#1a0a3e] to-[#3a0a5c] flex items-center justify-center p-4 relative overflow-hidden">
      <img
        src="https://customer-assets.emergentagent.com/job_80904b6f-7286-4784-ad3d-292b160c5a80/artifacts/crjane52_MEGA%20CHAT%20LOGO.png"
        alt=""
        aria-hidden="true"
        className="absolute inset-0 m-auto w-[85vmin] h-[85vmin] max-w-none object-contain opacity-[0.10] pointer-events-none select-none"
      />
      <div className="retro-window w-full max-w-md" data-testid="forgot-password-window">
        <div className="retro-title-bar">
          <span>MEGA! Chat - Password Recovery</span>
        </div>
        
        <div className="p-6 bg-[#C0C0C0]">
          <div className="text-center mb-6">
            <h1 className="yahoo-logo text-4xl mb-2">MEGA!</h1>
            <p className="font-verdana text-sm text-[#7B0099] font-bold">Password Recovery</p>
          </div>

          {sent ? (
            <div className="retro-inset p-6 text-center">
              <div className="text-4xl mb-4">📧</div>
              <p className="font-verdana text-sm mb-4">
                If an account with that email exists, we've sent a password reset link.
              </p>
              <p className="font-arial text-xs text-[#808080] mb-4">
                Check your email (and recovery email if set) for the reset link.
              </p>
              <Link to="/login" className="retro-button inline-block">
                Return to Login
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="retro-inset p-4 mb-4">
                <p className="font-arial text-xs">
                  Enter your email address or recovery email. We'll send you a link to reset your password.
                </p>
              </div>

              <div>
                <label className="block font-verdana text-sm mb-1">Email Address:</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="retro-input w-full"
                  required
                  data-testid="forgot-email-input"
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="retro-button w-full py-2"
                data-testid="forgot-submit-btn"
              >
                {loading ? "Sending..." : "Send Reset Link"}
              </button>

              <div className="text-center">
                <Link to="/login" className="font-arial text-xs text-[#0000EE] hover:underline">
                  Back to Login
                </Link>
              </div>
            </form>
          )}

          {/* Credit */}
          <div className="mt-4 text-center">
            <p className="font-arial text-xs text-[#808080]">created by mr_fuker</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
